import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SmartConnectorStatus } from '../types';
import { getSmartConnectorStatusesConfig } from '../helpers';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';
import { StaticText } from 'components/Inputs/StaticText';

type StatusTextProps = {
  status: SmartConnectorStatus;
};

const NO_VALUE = '—';

export const StatusText: FC<StatusTextProps> = ({ status }) => {
  const { t } = useTranslation();
  const { label = NO_VALUE, color = null } = useMemo(
    () => getSmartConnectorStatusesConfig(t)[status] || {},
    [t, status]
  );

  return (
    <TextEllipsisWithTooltip color={color}>{label}</TextEllipsisWithTooltip>
  );
};

export const StaticStatusTextInput: FC<StatusTextProps> = ({ status }) => {
  const { t } = useTranslation();
  const { label = NO_VALUE, color = null } = useMemo(
    () => getSmartConnectorStatusesConfig(t)[status] || {},
    [t, status]
  );

  return <StaticText color={color} label={t('Status')} value={label} />;
};
